import React from 'react';
import Button from 'reactstrap/lib/Button';
import classname from 'classnames';

export enum ProductListViewMode {
    cardView = 0,
    listView = 1,
    compactView = 2
}

export interface IProductListViewModeDisable {
    cardView?: boolean;
    listView?: boolean;
    compactView?: boolean;
}

export interface IProductListViewModeProps {
    viewMode: ProductListViewMode | undefined;
    cardButtonTxt?: string;
    listButtonTxt?: string;
    compactButtonTxt?: string;
    disableView?: IProductListViewModeDisable;
    setListViewMode?: () => void;
    setCardViewMode?: () => void;
    setCompactViewMode?: () => void;
}

export const ProductListViewModeComponent: React.FC<IProductListViewModeProps> = (props: IProductListViewModeProps) => {
    const { disableView } = props;

    return (
        <div className='defa-view-modes-selector'>
            {!disableView?.cardView && (
                <Button
                    className={classname('card_view', props.viewMode === ProductListViewMode.cardView ? 'msc-view-modes__selected' : '')}
                    title={props.cardButtonTxt || 'Varekort'}
                    aria-label={props.cardButtonTxt || 'Varekort'}
                    role='button'
                    onClick={props.setCardViewMode}
                >
                    <svg width='16px' height='16px' version='1.1' viewBox='0 0 1200 1200' xmlns='http://www.w3.org/2000/svg'>
                        <path d='m825 37.5h-787.5v1125h1125v-1125zm-75 75v262.5h-300v-262.5zm0 637.5h-300v-300h300zm75-300h262.5v300h-262.5zm-450 300h-262.5v-300h262.5zm-262.5-637.5h262.5v262.5h-262.5zm0 975v-262.5h262.5v262.5zm337.5 0v-262.5h300v262.5zm637.5 0h-262.5v-262.5h262.5zm-262.5-712.5v-262.5h262.5v262.5z' />
                    </svg>
                </Button>
            )}
            {!disableView?.listView && (
                <Button
                    className={classname('list_view', props.viewMode === ProductListViewMode.listView ? 'msc-view-modes__selected' : '')}
                    title={props.listButtonTxt || 'Liste'}
                    aria-label={props.listButtonTxt || 'Liste'}
                    role='button'
                    onClick={props.setListViewMode}
                >
                    <svg className='svg-icon' width='16px' height='16px' viewBox='0 0 24 24' fill='none'>
                        <path
                            d='M8.25 6.75H20.25M8.25 12H20.25M8.25 17.25H20.25M3.75 6.75H3.7575V6.7575H3.75V6.75ZM4.125 6.75C4.125 6.95711 3.95711 7.125 3.75 7.125C3.54289 7.125 3.375 6.95711 3.375 6.75C3.375 6.54289 3.54289 6.375 3.75 6.375C3.95711 6.375 4.125 6.54289 4.125 6.75ZM3.75 12H3.7575V12.0075H3.75V12ZM4.125 12C4.125 12.2071 3.95711 12.375 3.75 12.375C3.54289 12.375 3.375 12.2071 3.375 12C3.375 11.7929 3.54289 11.625 3.75 11.625C3.95711 11.625 4.125 11.7929 4.125 12ZM3.75 17.25H3.7575V17.2575H3.75V17.25ZM4.125 17.25C4.125 17.4571 3.95711 17.625 3.75 17.625C3.54289 17.625 3.375 17.4571 3.375 17.25C3.375 17.0429 3.54289 16.875 3.75 16.875C3.95711 16.875 4.125 17.0429 4.125 17.25Z'
                            stroke='#0F172A'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                    </svg>
                </Button>
            )}
            {!disableView?.compactView && (
                <Button
                    className={classname(
                        'compact_view',
                        props.viewMode === ProductListViewMode.compactView ? 'msc-view-modes__selected' : ''
                    )}
                    title={props.compactButtonTxt || 'Kompakt'}
                    aria-label={props.compactButtonTxt || 'Kompakt'}
                    role='button'
                    onClick={props.setCompactViewMode}
                >
                    <div className='compact_view__icon'>
                        <div />
                        <div />
                    </div>
                </Button>
            )}
        </div>
    );
};
